<template>
  <BaseLayout title="Create New Homework">
    <!-- Main Content (Center) -->
    <div class="container my-4">
      <h1 class="display-4 text-center">Create New Homework</h1>
      <div class="card">
        <div class="card-body">
          <HomeworkForm
            :homework="homework"
            :teachers="teachers"
            :semesters="semesters"
            buttonText="Create"
            @submitForm="createHomework"
          />
        </div>
      </div>
    </div>

    <!-- Right Sidebar Slot -->
    <template v-slot:right-sidebar>
      <div class="card p-3">
        <h5 class="card-title">Quick Actions:</h5>
        <router-link to="/homeworks" class="btn btn-primary mb-2">
          <i class="bi bi-arrow-left me-1"></i>
          Back to Homework List
        </router-link>
        <router-link to="/homeworks" class="btn btn-secondary">
          <i class="bi bi-x-circle me-1"></i>
          Cancel creating
        </router-link>
      </div>
    </template>

    <StemErrorModal ref="stemErrorModal"/>
  </BaseLayout>
</template>

<script>
import BaseLayout from '@/components/BaseLayout.vue';
import HomeworkForm from '@/components/HomeworkForm.vue';
import HomeworkController from '@/controllers/HomeworkController';
import Homework from '@/models/homework';
import StemErrorModal from '@/components/StemErrorModal.vue';
import { mapGetters } from 'vuex';

export default {
  name: 'HomeworkCreateView',
  components: {
    BaseLayout,
    HomeworkForm,
    StemErrorModal,
  },
  data() {
    return {
      homework: new Homework({}),
      teachers: [],
      semesters: [],
    };
  },
  computed: {
    ...mapGetters(['userId', 'semesterId', 'isTeacher']),
  },
  async created() {
    try {
      // Check if the user is a teacher
      if (!this.isTeacher) {
        this.$store.dispatch('triggerAlert', {
          type: 'error',
          title: 'Error',
          message: 'You are not authorized to access this page.',
        });
        this.$router.push('/homeworks');
        return;
      }
      // Set teacher and semester
      this.homework.teacher_id = this.userId;
      this.homework.semester_id = this.semesterId;
    } catch (error) {
      this.$refs.stemErrorModal.show('Error', error.message);
    }
  },
  methods: {
    async createHomework(homeworkData) {
      try {
        this.homework = await HomeworkController.createHomework(homeworkData);

        // Upload new files
        await this.uploadFiles(this.homework.id, homeworkData);

        // Dispatch alert action
        this.$store.dispatch('triggerAlert', {
          title: 'Success',
          message: 'Homework was created successfully',
          type: 'success'
        });

        this.$router.push('/homework/' + this.homework.id);
      } catch (error) {
        this.$refs.stemErrorModal.show('Error', error.message);
      }
    },
    async uploadFiles(homework_id, homeworkData) {
      if (homeworkData.homework_files.length > 0) {
        const formData = new FormData();
        for (const file of homeworkData.homework_files) {
          formData.append('files', file);
        }
        await HomeworkController.uploadFiles(homework_id, formData);
      }
    }
  },
};
</script>